import React, { useEffect, useState } from 'react';

import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { type ModalProps } from '@pkg/components';
import { Modal } from '@pkg/components/Modal';
import { useAppDispatch, useCreateWishlist } from '@pkg/hooks';
import { fetchRandomName } from '@pkg/utils';

import { wishlistActions } from '@app/store/slices';

import { CreateWishlistContent } from '../AddToWishlistModal/CreateWishlist/CreateWishlistContent';
import { Heading, ModalLayout, SectionWrapper, Subheading } from '../AddToWishlistModal/CreateWishlist/styles';
import { StyledStar } from '../AddToWishlistModal/styles';

export interface CreateWishlistModalProps {
    onClose: ModalProps['onClose'];
}

export const CreateWishlistModal = ({ onClose }: CreateWishlistModalProps) => {
    const { t: translate } = useTranslation(['nft_details']);
    const dispatch = useAppDispatch();

    const [popoverFullyOpen, setPopoverFullyOpen] = useState(false);

    const handleClose = () => {
        if (!popoverFullyOpen) onClose();
    };

    const { mutateAsync: createWishlist, isLoading: isLoadingCreate } = useCreateWishlist();
    const navigate = useNavigate();

    const [wishlistName, setWishlistName] = useState('');
    const [isLoadingGeneratedName, setIsLoadingGeneratedName] = useState(true);
    useEffect(() => {
        fetchRandomName()
            .then((autoGeneratedName) => setWishlistName(autoGeneratedName))
            .finally(() => setIsLoadingGeneratedName(false));
    }, []);

    const [isPrivate, setIsPrivate] = useState(false);

    const handleCreateWishlist = () => {
        createWishlist({ name: wishlistName, isPrivate }).then((res) => {
            if (res.ok && res.value) {
                onClose();
                dispatch(wishlistActions.setShowCreateWishListToast(true));
                navigate(`/wishlists/${res.value.slug}`);
            }
        });
    };

    return (
        <Modal onClose={handleClose} mobileDarkBackground>
            <ModalLayout>
                <SectionWrapper>
                    <StyledStar forceSprite emojiID="⭐" />
                    <Heading>{translate('detail_view_wishlist_create_heading')}</Heading>
                    <Subheading>{translate('detail_view_wishlist_create_subheading')}</Subheading>
                </SectionWrapper>

                <CreateWishlistContent
                    disabled={isLoadingGeneratedName}
                    handleCreate={handleCreateWishlist}
                    setPopoverFullyOpen={setPopoverFullyOpen}
                    setWishlistName={setWishlistName}
                    wishlistName={wishlistName}
                    setIsPrivate={setIsPrivate}
                    isPrivate={isPrivate}
                    isLoading={isLoadingCreate}
                />
            </ModalLayout>
        </Modal>
    );
};
